// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1ejb{gap:var(--ds-space-300,24px)}\n._zulppxbi{gap:var(--ds-space-200,1pc)}._10fp1h6o{justify-self:center}\n._18u0oahv{margin-left:var(--ds-space-600,3pc)}\n._19pkoahv{margin-top:var(--ds-space-600,3pc)}\n._1wpz1h6o{align-self:center}\n._2hwxoahv{margin-right:var(--ds-space-600,3pc)}\n._4cvr1h6o{align-items:center}\n._6a6z1h6o{justify-items:center}\n._otyroahv{margin-bottom:var(--ds-space-600,3pc)}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
